/* Card tag clamp (all viewports): chips overflow pattern — "+N" pill inline at the end of row 2, expands in place */
(function () {
  if (window.__cardTagClampInit) return;
  window.__cardTagClampInit = true;

  // chips are 26px tall with 6px row gap; a chip starting at >=60px sits on row 3+
  var ROW3_TOP = 60;
  // collection cards (grid + list layouts) + CCTV landing-page result cards + home product lists
  var CONTAINERS = '.js-collection-products .js-card-tags, .cres__grid .crc__tags, [data-ui-component="Product Lists Section"] .js-card-tags';

  function chips(el) {
    return Array.prototype.slice.call(el.querySelectorAll('.crc__tag, .subtext.background'));
  }

  function reset(el) {
    chips(el).forEach(function (c) { c.classList.remove('tag-clamp-hidden'); });
    var pill = el.querySelector('.card__tags-more');
    if (pill) pill.remove();
    el.classList.remove('is-expanded');
  }

  function clamp(el) {
    // never collapse a card the user explicitly expanded (mobile resize fires on address-bar show/hide)
    if (el.classList.contains('is-expanded')) return;
    reset(el);
    var all = chips(el);
    if (!all.length) return;
    if (all[all.length - 1].offsetTop < ROW3_TOP) return;

    var pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'card__tags-more';
    pill.setAttribute('aria-expanded', 'false');
    pill.setAttribute('aria-label', 'Show all specifications');
    var label = document.createElement('span');
    label.className = 'card__tags-more-label';
    var caret = document.createElement('span');
    caret.className = 'card__tags-more-caret';
    pill.appendChild(label);
    pill.appendChild(caret);
    el.appendChild(pill);

    var hidden = 0;
    for (var i = all.length - 1; i >= 0; i--) {
      if (all[i].offsetTop >= ROW3_TOP) {
        all[i].classList.add('tag-clamp-hidden');
        hidden++;
      }
    }
    label.textContent = '+' + hidden;

    // the pill itself may push past row 2 — reclaim space from the tail of row 2
    var guard = 0;
    while (pill.offsetTop >= ROW3_TOP && guard < all.length) {
      for (var j = all.length - 1; j >= 0; j--) {
        if (!all[j].classList.contains('tag-clamp-hidden')) {
          all[j].classList.add('tag-clamp-hidden');
          hidden++;
          break;
        }
      }
      label.textContent = '+' + hidden;
      guard++;
    }
    pill.dataset.more = '+' + hidden;
  }

  function refresh() {
    document.querySelectorAll(CONTAINERS).forEach(clamp);
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.card__tags-more');
    if (!pill) return;
    var el = pill.closest('.js-card-tags, .crc__tags');
    if (!el) return;
    if (el.classList.contains('is-expanded')) {
      el.classList.remove('is-expanded');
      clamp(el);
    } else {
      el.classList.add('is-expanded');
      chips(el).forEach(function (c) { c.classList.remove('tag-clamp-hidden'); });
      var lbl = pill.querySelector('.card__tags-more-label');
      if (lbl) lbl.textContent = 'Less';
      pill.setAttribute('aria-expanded', 'true');
      el.appendChild(pill);
    }
  });

  window.SHTCardTagClamp = refresh;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  var rT;
  window.addEventListener('resize', function () {
    clearTimeout(rT);
    rT = setTimeout(refresh, 150);
  });

  // LP result grids render cards client-side — re-clamp when their contents change
  document.querySelectorAll('.js-cres-grid').forEach(function (grid) {
    var mT;
    new MutationObserver(function () {
      clearTimeout(mT);
      mT = setTimeout(refresh, 50);
    }).observe(grid, { childList: true });
  });

  // grid/list switcher toggles a class on the container — chips rewrap, so re-clamp
  document.querySelectorAll('.js-collection-products').forEach(function (wrap) {
    var cT;
    new MutationObserver(function () {
      clearTimeout(cT);
      cT = setTimeout(refresh, 50);
    }).observe(wrap, { attributes: true, attributeFilter: ['class'], childList: true });
  });

  // home product-lists tabs: hidden panels can't be measured — re-clamp when a panel becomes visible
  document.querySelectorAll('[data-ui-component="Product Lists Section"] .js-tab-panel').forEach(function (panel) {
    var pT;
    new MutationObserver(function () {
      clearTimeout(pT);
      pT = setTimeout(refresh, 50);
    }).observe(panel, { attributes: true, attributeFilter: ['class'] });
  });
})();
